import * as React from "react";
import { cn } from "@/lib/cn";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      className={cn("flex h-12 min-w-0 w-full max-w-full rounded-2xl border border-white/10 bg-white/6 px-4 text-sm text-white outline-none placeholder:text-slate-400 focus:border-blurple-400", className)}
      ref={ref}
      {...props}
    />
  ),
);

Input.displayName = "Input";
